<template>
  <div>
    <PDF
      :show-layout="false"
      :float-layout="true"
      :enable-download="fazDownload"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="nomeArquivo"
      :pdf-quality="2"
      :manual-pagination="true"
      :pdf-format="formatoPDF"
      :pdf-orientation="orientacaoPDF"
      pdf-content-width="800px"
      ref="referenciaInterna"
      @beforeDownload="abrirNovaGuia"
    >
      <template  v-slot:pdf-content>
        <slot></slot>
      </template>
    </PDF>
  </div>
</template>

<script>
import gpdf from './g-pdf.js' 
export default gpdf
</script>

<style scoped></style>
